import { render, staticRenderFns } from "./TaxonomiaDetalle.vue?vue&type=template&id=7ada9b96"
import script from "./TaxonomiaDetalle.vue?vue&type=script&lang=js"
export * from "./TaxonomiaDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports